import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { ClientUserResource } from 'dy-frontend-http-repository/lib/modules/ClientUser/resources';
import { ComputedLicenceResource } from 'dy-frontend-http-repository/lib/modules/ComputedLicence/resources';
import { PaymentAccountResource } from 'dy-frontend-http-repository/lib/modules/PaymentAccount/resources';
import { QuotaUsageResource } from 'dy-frontend-http-repository/lib/modules/QuotaUsage/resources';
import domain from './domain';
import { resetClient, resetClientPaymentAccount, resetComputedLicence, resetQuotaUsage } from './events';
import { ComputedLicence, QuotaUsageContainer } from 'dy-frontend-shared/lib/data/valueObjects';

// Client
export const $client = domain.createStore<ClientUserResource | null>(null).reset(resetClient);

// Client payment account
export const $clientPaymentAccount = domain
    .createStore<PaymentAccountResource | null>(null)
    .reset(resetClientPaymentAccount);

// Computed licence
export const $computedLicence = domain.createStore<ComputedLicence | null>(null).reset(resetComputedLicence);

// Quota usage
export const $quotaUsage = domain
    .createStore<QuotaUsageContainer | null>(null)
    .reset(resetQuotaUsage);
